import React from 'react';

function renderHighlightedBlock(data, index) {
  return (
    <section key={index} className={'wide bgGrayCard'}>
      <mark>
        <b>{data.LABEL}</b>
        <div dangerouslySetInnerHTML={{ __html: data.CONTENT }} />
      </mark>
    </section>
  );
}

export default renderHighlightedBlock;